import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { extractorNomePessoa } from "@/Models/Pessoa/Pessoa";
import { useAlunoListar } from "@/Services/Domain/Pessoa/AlunoService";
import Ordenar from "@/Utils/Ordenacao";

export interface IAlunoSelectProps extends ISelectComPesquisaProps {
    /** @default {codAluno} */
    keySelector?:'codPessoa'|'codAluno'
}

export default function AlunoSelect({
    placeholder,
    keySelector,
    disabled,
    ...rest
}:IAlunoSelectProps) {
    const {
        data,
        isError,
        isLoading
    } = useAlunoListar({

    });

    return <SelectComPesquisa
        {...rest}
        loading={isLoading}
        disabled={isError ? true : disabled}
        placeholder={placeholder === undefined ? "Selecione" : placeholder}
        options={data?.data
            .map(m => {
                return {
                    label : extractorNomePessoa(m.pessoa!),
                    value : keySelector === 'codPessoa' ? m.pessoa!.codigo : m.codigo
                }
            })
            .sort((a, b) => Ordenar.String(a.label, b.label))
        }
    />
}